import { Route } from "./types";

export const isRouteVisible = (route: Route): boolean => (route.condition === undefined || route.condition)